__turbopack_context__.v({
  "MuiTypography-root": "product_option-module-scss-module__8R7sZa__MuiTypography-root",
  "active": "product_option-module-scss-module__8R7sZa__active",
  "category_color_swatch": "product_option-module-scss-module__8R7sZa__category_color_swatch",
  "chicklet_options": "product_option-module-scss-module__8R7sZa__chicklet_options",
  "option": "product_option-module-scss-module__8R7sZa__option",
  "option-list": "product_option-module-scss-module__8R7sZa__option-list",
  "option-wrapper": "product_option-module-scss-module__8R7sZa__option-wrapper",
  "product-option-img": "product_option-module-scss-module__8R7sZa__product-option-img",
  "selected": "product_option-module-scss-module__8R7sZa__selected",
  "show-more-btn": "product_option-module-scss-module__8R7sZa__show-more-btn",
  "type-chicklet": "product_option-module-scss-module__8R7sZa__type-chicklet",
  "type-color": "product_option-module-scss-module__8R7sZa__type-color",
  "type-icon": "product_option-module-scss-module__8R7sZa__type-icon",
});
